import type { AnyAction } from 'redux';

const defaultState = 0;

const INCREMENT = 'app/jobCreationInProgressCount/INCREMENT';
const DECREMENT = 'app/jobCreationInProgressCount/DECREMENT';

export const actionIncrementJobCreationInProgressCount = () => ({
  type: INCREMENT,
});

export const actionDecrementJobCreationInProgressCount = () => ({
  type: DECREMENT,
});

export default (state = defaultState, action: AnyAction) => {
  switch (action.type) {
    case INCREMENT:
      return state + 1;
    case DECREMENT:
      return state - 1;
    default: {
      return state;
    }
  }
};

export const forTest = {
  defaultState,
  INCREMENT,
  DECREMENT,
};
